<template>
  <div class="container" @click="_closeAll">
    <template v-if="status === 200 && channelInfo.id">
      <skin :layoutColor="channelInfo.layoutColor"></skin>
      <mobile v-if="isMobile"></mobile>
      <pc v-else></pc>
    </template>
    <template v-else-if="status === 404">
      <status404></status404>
    </template>
    <template v-else-if="status === 408">
      <status408></status408>
    </template>
    <template v-else>
      <div class="loading"></div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { watchTime } from "@/api/apiWS";
// import REPORT from "@/utils/report";
import DMS from "@/utils/Mixin/dms";
import UserAgent from "@/utils/UserAgent/index";
const skin = (resolve) => require(["@/assets/skin/index"], resolve);
const viewPc = (resolve) => require(["@/components/view/pc"], resolve);
const viewMobile = (resolve) => require(["@/components/view/mobile"], resolve);
const status404 = (resolve) => require(["@/components/view/404"], resolve);
const status408 = (resolve) => require(["@/components/view/408"], resolve);
import { ENV_CONFIG } from '@/config';
export default {
  components: {
    skin: skin,
    pc: viewPc,
    mobile: viewMobile,
    status404: status404,
    status408: status408,
  },
  mixins: [DMS],
  data() {
    return {
      timer: null,
      isMobile: true,
    };
  },
  head() {
    return {
      title: this.domTitle,
    };
  },
  computed: {
    ...mapGetters({
      status: "status",
      channelInfo: "channelInfo",
      userInfo: "userInfo",
      isOpenLimitedMode: "isOpenLimitedMode",
    }),
    domTitle() {
      if (this.status === 200) {
        return this.channelInfo.name || "";
      } else if (this.status === 404) {
        return "抱歉，您的页面迷路了";
      } else if (this.status === 408) {
        return "直播间人数较多，请耐心等待";
      } else {
        return this.channelInfo.name || "";
      }
    },
    id() {
      return this.$route.params.id || this.$route.query.id
    }
  },
  watch: {
    'channelInfo.uin'() {
      this.get_userInfo();
      const websocketHeartbeat = require("@/utils/timer").default;
      this.timer = websocketHeartbeat({
        url: watchTime,
        pingTimeout: 5000,
        pongTimeout: 5000,
        manualStart: false,
        repeatLimit: 10,
        userInfo: {
          userId: this.userInfo.id || 0,
          //  "token": this.token,
          id: this.channelInfo.id,
          type: "tv",
          uin: this.channelInfo.uin,
          liveNowStatus: Number(this.channelInfo.liveStatus),
        },
        webworker: false,
      })
        .useIt("uuid")
        .useIt("ua");

      this.set_uuid(this.timer.uuid);
          // 进入连接
      this.timer.onOpen = (e) => {
        this.timer.send("first");
      };
      this.timer.onMessage = (e) => {
        console.log(`onmessage: ${e.data}`);
      };
    },
    domTitle() {
      document.title = this.domTitle
    }
  },
  async created() {
    // REPORT($sentry, { AppId: query.id, Uin: query.uin });
    await this.$store.dispatch('get_control', { id: this.id, uin: this.$route.query.uin });
  },
  async mounted() {
    console.log(ENV_CONFIG, 333)
    if (this.status !== 200) {
      return false;
    }
    let mobile = Number(this.$route.query.mobile);
    this.isMobile = mobile || UserAgent.isMobile();
    this.set_corpId(Number(this.$route.query.corpId));
    // bus注册ws暂停和开始事件
    this.$Bus.$on("ws-start", () => {
      this.timer && this.timer.start();
    });
    this.$Bus.$on("ws-stop", () => {
      this.timer && this.timer.stop();
    });
    this.$Bus.$on("ws-changeLiveNowStatus", (newState) => {
      this.timer.useIt("userInfo", { liveNowStatus: newState });
    });
    this._installDrainage()
  },
  methods: {
    ...mapMutations({
      set_corpId: "set_corpId",
      set_uuid: "set_uuid",
      set_drainage_state: "set_drainage_state",
    }),
    ...mapActions({
      get_userInfo: "get_userInfo"
    }),
    _isWebview() {
      return (
        this.isOpenLimitedMode ||
        (navigator &&
          (navigator.userAgent.toLowerCase().includes("webview") ||
            navigator.userAgent.toLowerCase().includes("mediacloudclient") ||
            navigator.userAgent.toLowerCase().includes("dtdreamweb")))
      )
    },
    _installDrainage() {
      if (this.status !== 200) return
      if (this._isWebview()) {
        this.set_drainage_state(0)
        return
      }
      this.$nextTick(() => {
        this.$Bus.$emit("install-drainage")
      })
    },
    _closeAll() {
      this.$Bus.$emit("bus-remEnclosure");
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    background-color: #fbfbfb;
    background-image: url("~@/assets/img/loading.gif");
    background-repeat: no-repeat;
    background-size: 270px auto;
    background-position: center center;
  }
}
</style>
